// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React from 'react';
import { toast } from 'react-toastify';
import Scrollbars from 'react-custom-scrollbars';
import SignatureCanvas from 'react-signature-canvas';

// Components
import User from './User';
import Navigation from './Navigation';
import Checkbox from './Checkbox';

// Utilities
import copyText from '../utilities/copy';
import testPasswordStrength from '../utilities/passwordStrength';

// Styles
import '../styles/settings.css';

export default class Account extends React.Component {

    state = {
        name: "",
        email: "",
        sendDailySummaryByEmail: false,
        notifyByEmail: false,
        enableDarkMode: false,
        changePassword: false,
        password: "password",
        confirm: "",
        changed: false,
        signatureChanged: false
    }

    componentDidMount = async () => {
        if(!this.props.user._id || this.props.user._id === null) 
            return this.props.loading(1005, "", false, "settings-account");  

        this.loadUserForm(this.props.user); 
    }

    componentWillReceiveProps = async (next) => {
        if(!next.user || !next.user._id || next.user._id === null || next.user._id === this.props.user._id) 
            return 
    
        this.loadUserForm(next.user);
    }

    loadUserForm = async (user) => {
        this.props.loaded('settings-account');
        const {
            name,
            email,
            sendDailySummaryByEmail,
            notifyByEmail,
            enableDarkMode,
            signature
        } = user;
        await this.setState({
            name,
            email,
            sendDailySummaryByEmail,
            notifyByEmail,
            enableDarkMode
        });
        if (signature && this.signature)
            this.signature.fromDataURL(signature);
    }

    togglePreference = (prop) => {
        this.setState({
            [prop]: !this.state[prop],
            changed: true
        });
    }

    render = () => {
        const passwordStrength = testPasswordStrength(this.state.password);
        const savable = this.state.changed && (!this.state.changePassword || (this.state.password && passwordStrength === "ok" && this.state.password === this.state.confirm));

        return (<>

            {/* Navigation Bar */}
            <Navigation
                user={this.props.user}
                team={this.props.team}
            />

            {/* User & Notifications */}
            <User
                clearNotification={this.props.clearNotification}
                user={this.props.user}
                updateUser={this.props.updateUser}
                switchTeam={this.props.switchTeam}
                team={this.props.team}
            />

            <div className="main-title full">
                <div style={{ float: 'left' }}>Manage My Account</div>
                {savable && <div
                    className="settings-save"
                    title="Click to save changes..."
                    onClick={async () => {
                        const {
                            name,
                            email,
                            sendDailySummaryByEmail,
                            notifyByEmail,
                            enableDarkMode
                        } = this.state;
                        await this.props.loading();

                        // Signature update
                        let signature;
                        if (this.signature && this.state.signatureChanged)
                            signature = this.signature.toDataURL();

                        await this.props.updateUser({
                            _id: this.props.user._id,
                            name,
                            email,
                            sendDailySummaryByEmail,
                            notifyByEmail,
                            enableDarkMode,
                            password: this.state.changePassword && this.state.password && this.state.password === this.state.confirm ? this.state.password : undefined,
                            signature: this.signature && this.state.signatureChanged ? signature: undefined
                        });
                        await this.setState({
                            changed: false,
                            changePassword: false,
                            password: "password",
                            confirm: ""
                        });
                        this.props.loaded();
                    }}
                >Save</div>}
            </div>

            <div className="main-content full">
                <Scrollbars>
                    <div className="settings settings-user-manage">

                        <h2>My Identity</h2>

                        <label>Full name</label>
                        <input
                            id="name"
                            name="name"
                            type="text"
                            placeholder="Enter your full name..."
                            value={this.state.name}
                            onChange={e => this.setState({ name: e.target.value, changed: true })}
                        />

                        <label>Email address</label>
                        <input
                            title="If you need to change your email address, please contact support."
                            id="email"
                            name="email"
                            type="text"
                            disabled={true}
                            placeholder="Enter your email..."
                            value={this.state.email}
                            onChange={e => this.setState({ email: e.target.value, changed: true })}
                            style={{opacity: 0.5, cursor: 'not-allowed'}}
                        />

                        

                        {/* <label>Last Access</label>
                        <input
                            id="lastaccess"
                            name="lastaccess"
                            type="text"
                            placeholder="Loading..."
                            value={formatDate(this.props.user.lastAccess)}
                            disabled
                        /> */}
                        {
                            !this.props.user?.sso?.enabled && <>
                            <h2>Access Control</h2>
                            <label>Password</label>
                            <div className="settings-password-container">
                                <input
                                    id="password"
                                    name="password"
                                    type="password"
                                    className={this.state.changePassword && passwordStrength !== "ok" ? "input-error-no-alert" : ""}
                                    placeholder="Enter new password..."
                                    value={this.state.password}
                                    onChange={e => this.setState({ password: e.target.value, changed: true })}
                                />
                                {!this.state.changePassword && <div
                                    className="settings-password-button"
                                    onClick={() => {
                                        this.setState({
                                            changePassword: true,
                                            password: ""
                                        });
                                        document.getElementById("password").focus();
                                    }}
                                >Change password</div>}
                                {this.state.changePassword && passwordStrength !== "ok" ? <div
                                    className="input-error-message"
                                >{passwordStrength}</div> : ""}
                            </div>

                            {this.state.changePassword && <>
                                <label>Confirm</label>
                                <input
                                    id="confirm"
                                    name="confirm"
                                    type="password"
                                    className={this.state.password !== this.state.confirm ? "input-error-no-alert" : ""}
                                    placeholder="Confirm password..."
                                    value={this.state.confirm}
                                    onChange={e => this.setState({ confirm: e.target.value, changed: true })}
                                />
                                {this.state.changePassword && this.state.password !== this.state.confirm ? <div
                                    className="input-error-message"
                                >Passwords do not match.</div> : ""}
                            </>}
                            </>
                        }
                        

                        <div style={{ clear: 'both' }} />

                        <h2>Sign Documents</h2>

                        <label>My Signature</label>
                        <div style={{ position: 'relative', float: 'left' }}>
                            <SignatureCanvas
                                ref={ref => { this.signature = ref; }}
                                velocityFilterWeight={0.9}
                                minDistance={1}
                                maxWidth={1.5}
                                penColor={"rgb(0,100,140"}
                                throttle={32}
                                canvasProps={{
                                    width: 390,
                                    height: 140,
                                    className: "settings-signature-pad"
                                }}
                                onEnd={() => this.setState({
                                    changed: true,
                                    signatureChanged: true
                                })}
                            />
                            {this.signature && !this.signature.isEmpty() && <div
                                className="settings-signature-clear"
                                onClick={() => this.signature ? this.signature.clear() : ""}
                            >
                                Clear
                            </div>}
                        </div>
                        <div className="settings-signature-underline">
                            Sign above this line
                        </div>

                        <h2>My Preferences</h2>

                        <div style={{ paddingLeft: 10, paddingTop: 10 }}>
                            <Checkbox
                                className="settings-checkbox"
                                label="Send a daily summary of documents received."
                                checked={this.state.sendDailySummaryByEmail}
                                onToggle={() => this.togglePreference("sendDailySummaryByEmail")}
                            />

                            <Checkbox
                                className="settings-checkbox"
                                label="Notify me by email when I'm tagged or assigned."
                                checked={this.state.notifyByEmail}
                                onToggle={() => this.togglePreference("notifyByEmail")}
                            />

                            <Checkbox
                                className="settings-checkbox"
                                label="Use 'Dark Mode' to conserve energy."
                                checked={this.state.enableDarkMode}
                                onToggle={() => this.togglePreference("enableDarkMode")}
                            />
                        </div>

                        {/* Only for admins */}
                        {this.props.user && this.props.user.isAdmin && <>
                            <h2>Developer</h2>
                            <p><a href="https://stax.readme.io/reference/overview">Learn more</a> about how the <a href="https://stax.readme.io/reference/overview">Stax·ai Developer API</a> lets you integrate Stax·ai into other software.</p>
                            <div className="settings-developer-info-container">
                                <div className="settings-developer-info">
                                    <label>Team ID</label>
                                    <div
                                        onClick={() => {
                                            copyText(this.props.team?._id);
                                            toast.info("Copied to clipboard");
                                        }}
                                    >{this.props.team?._id}</div>
                                </div>
                                <div className="settings-developer-info">
                                    <label>User ID</label>
                                    <div onClick={() => {
                                        copyText(this.props.user?._id);
                                        toast.info("Copied to clipboard");
                                    }}>{this.props.user?._id}</div>
                                </div>
                            </div>

                            {this.props.user && this.props.user.keys && this.props.user.keys.map((key,idx) => <div
                                key={idx}
                                className="settings-user-apikey"
                            >
                                <label>Click to copy →</label>
                                <input
                                    id={"copykey-"+idx}
                                    name="copykey"
                                    type="text"
                                    style={{ cursor: 'pointer' }}
                                    title="Click to copy key"
                                    placeholder="Loading..."
                                    value={key}
                                    onClick={(e) => {
                                        copyText(e.target.value);
                                        toast.info("Copied to clipboard");
                                    }}
                                    readOnly
                                />
                                <img
                                    className="settings-user-apikey-delete"
                                    src="https://static.stax.ai/images/icons/remove.png"
                                    alt="Delete key"
                                    title="Delete API key"
                                    onClick={async () => {
                                        await this.props.loading();
                                        let keys = [ ...this.props.user.keys ];
                                        keys.splice(idx,1);
                                        await this.props.updateUser({
                                            _id: this.props.user._id,
                                            keys
                                        });
                                        this.props.loaded();
                                    }}
                                />
                            </div>)}

                            <div
                                className="settings-user-apikey-new"
                                title="Click to generate a new API access key"
                                onClick={async () => {
                                    await this.props.loading();
                                    let apiKey = "";
                                    for (let i=0; i<4; i++)
                                        apiKey += Math.random().toString(36).substring(3);
                                    await this.props.updateUser({
                                        _id: this.props.user._id,
                                        keys: [
                                            ...this.props.user.keys,
                                            apiKey
                                        ]
                                    });
                                    this.props.loaded();
                                }}
                            >Create a new API key</div>
                        </>}

                    </div>
                </Scrollbars>
            </div>
        
        </>);
    }

};